import { RemoteConfig } from './types';
import { DEFAULT_CONFIG } from './constants';


const remoteConfig = (state: RemoteConfig = DEFAULT_CONFIG) => state;

export default remoteConfig;
